import { cn } from '@shared/lib/cn';

export interface TextareaSkeletonProps {
  /** 너비 · 높이를 바꿀 때. 기본은 부모 너비 × 96 */
  className?: string;
}

/** Textarea 의 status=init — 입력 상자 크기의 면 */
export function TextareaSkeleton({ className }: TextareaSkeletonProps) {
  return (
    <div
      aria-hidden="true"
      data-status="init"
      className={cn('skeleton-pulse', 'h-24 w-full rounded-md bg-bg-pressed', className)}
    />
  );
}
